import { Form } from "components";

export function Filters({ filters, onChange, onClean }) {
  return (
    <Form>
      <div className="row">
        <Form.Field className="col-md-4">
          <Form.Label>Título</Form.Label>
          <Form.Input
            name="title"
            placeholder='Digite o texto e pressione "Enter"'
            onChange={(e) => onChange("title", e.target.value)}
            value={filters.title}
          />
        </Form.Field>

        <Form.Field className="col-md-4">
          <Form.Label>Início em</Form.Label>
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={filters.start_at}
            onChange={(value) => onChange("start_at", value)}
          />
        </Form.Field>

        <Form.Field className="col-md-4">
          <Form.Label>Fim em</Form.Label>
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={filters.end_at}
            onChange={(value) => onChange("end_at", value)}
            minDate={filters.start_at}
            disabled={!filters.start_at}
          />
        </Form.Field>
      </div>

      <div className="row text-center">
        <Form.Field>
          <Form.Button
            type="button"
            className="button-clean-filter margin-top-0"
            onClick={onClean}
          >
            Resetar filtros
          </Form.Button>
        </Form.Field>
      </div>
    </Form>
  );
}
